import { createContext, useContext } from "react";

/** Il cliente finale (percorso QR) vede solo le conclusioni sulle voci, mai le etichette del nostro lavoro
 *  («Da verificare», «Non controllata», «Non verificabile»): Alfonso 19/10. L'agenzia vede tutto. */
export const VistaCliente = createContext(false);
export const useVistaCliente = () => useContext(VistaCliente);
